export const contactsData = {
  email: "bhaskarkumar0022@gmail.com",
  phone: "+91-75450*****",
  address: "Bangalore, Karnataka, 560065",

  sheetAPI: "",
};
